import React, { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebCorrectOrderAudioRecipe({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;
    const audioResources = ResourceLinks.audio;

    // for audio header
    const [headerAudioInfo, setHeaderAudioInfo] = useState(data.headerAudioInfo);
    const [playingAudioUrl, setPlayingAudioUrl] = useState("");
    const refs = useRef({});

    const [websiteChoices, setWebsiteChoices] = useState({});
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);
    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );
    const [answerHeader, setAnswerHeader] = useState(data.answerHeader);
    const [answerBox, setAnswerBox] = useState(data.answerBox);
    const [selectedChoice, setSelectedChoice] = useState(null);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setHeaderAudioInfo(data.headerAudioInfo);
        setPlayingAudioUrl("");
        setWebsiteChoices({});
        setSelectedKeyPrevious(null);
        setAvailableChoices(makeArrayRandom(data.choices));
        setAnswerHeader(data.answerHeader);
        setAnswerBox(data.answerBox);
        setSelectedChoice(null);
    }, [question,
        data.headerAudioInfo,
        data.choices,
        data.answerHeader,
        data.answerBox
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (websiteChoices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === websiteChoices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== websiteChoices[index]?.value)) {
            let currentWebsiteChoices = {...websiteChoices};
            const previousChoice = websiteChoices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentWebsiteChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentWebsiteChoices = {
                ...currentWebsiteChoices,
                [index]: {
                    value: selectedChoice.value,
                    image: selectedChoice.image,
                },
            }
            setWebsiteChoices(currentWebsiteChoices);

            if (
                typeof questionData.answer.value === "object" &&
                !Array.isArray(questionData.answer.value)
            ) {

            } else {
                const updatedAnswer = Object.values(currentWebsiteChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
        }
    };

    const handleRemoveChoice = (index) => {
        const removedChoice = websiteChoices[index];

        if (removedChoice) {
            setWebsiteChoices((prevChoices) => {
                const newChoices = { ...prevChoices };
                delete newChoices[index];

                if (
                    typeof questionData.answer.value === "object" &&
                    !Array.isArray(questionData.answer.value)
                ) {
                    const answerKeys = Object.keys(
                        questionData.answer.value
                    );

                    const formattedAnswer = answerKeys.reduce(
                        (acc, key, keyIndex) => {
                            acc[key] = newChoices[keyIndex]?.value || null;
                            return acc;
                        },
                        {}
                    );

                    // set to false so that next button will be disabled
                    const canProceed = false;
                    onAnswer({
                        canProceed,
                        answer: formattedAnswer,
                    });
                } else {
                    const updatedAnswer = Object.values(newChoices).map(
                        (choice) => choice.value
                    );

                    // set to false so that next button will be disabled
                    const canProceed = updatedAnswer.length > 0;
                    onAnswer({
                        canProceed,
                        answer: updatedAnswer,
                    });
                }

                return newChoices;
            });

            setAvailableChoices((prevChoices) => [
                ...prevChoices,
                {
                    value: removedChoice.value,
                    image: removedChoice.image,
                },
            ]);
        }
    };

    const playAudio = (url) => {

        const previousUrl = playingAudioUrl;
        if (playingAudioUrl !== "") {
                // we will control the play or pause
            if (refs.current[previousUrl]) {
                refs.current[previousUrl].pause();
                setPlayingAudioUrl("");
            } else {
                // set url
                setPlayingAudioUrl(url);
                refs.current[url].play();
            }
        } else {
            // set url
            setPlayingAudioUrl(url);
            refs.current[url].play();
        }
    }

    const handleEnded = () => {
        setPlayingAudioUrl("");
    }

    return (
        <Box
            sx={{
            }}
        >
            <Button
                sx={{
                    marginBottom: "20px",
                    position: "relative",
                    outline: "none",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "hsl(204,100%,47%)",
                    borderBottom: "5px solid hsl(204,100%,37%)",
                    borderRadius: "5px",
                    minWidth: "15em",
                    minHeight: "3em",
                    fontWeight: "bold",
                    textAlign: "left",
                    justifyContent: "left",
                    paddingLeft: "35px",
                    margin: "5px",
                    marginLeft: "15px",
                    color: "black",
                    "&:hover": {
                            backgroundColor: "hsl(204,100%,44%)",
                            borderBottomColor: "hsl(204,100%,34%)",
                        },
                    fontSize: "18px",
                }}
                onClick={() => playAudio(headerAudioInfo.audioSrc)}
            >{headerAudioInfo.value}
                <Box component="img"
                    src={playingAudioUrl === "" ? "data:image/png;base64,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"
                    : "data:image/png;base64,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"}
                    sx={{
                        position: "absolute",
                        left: "-14px",
                        top: "-2.5px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        textAlign: "left",
                    }}
                    alt="Play Img"
                />
                <audio ref={(el) => refs.current[headerAudioInfo.audioSrc] = el} src={`${audioResources}${headerAudioInfo.audioSrc}`} onEnded={handleEnded}/>
            </Button>

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                textAlign: "center",
            }}>
                {/* For Choices */}
                <Box sx={{
                    marginRight: "10px",
                    textAlign: "center"
                }}>
                    <Box sx={{
                        width: "790px",
                        height: "204px",
                        marginBottom: "10px",
                        padding: "10px",
                        border: "1px dashed lightgrey",
                        textAlign: "center",
                    }}>
                        <Box sx={{
                            position: "relative",
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            top: "0",
                            left: "0,",
                            textAlign: "center"
                        }}>
                            {availableChoices.map((choice, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        borderBottom: "10px solid rgb(52, 148, 186)",
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "167px",
                                        width: "142px",
                                        boxSizing: "content-box",
                                        backgroundColor: "#aad6e7",
                                        padding: "4px",
                                        lineHeight: "0.8em",
                                        textAlign: "center",
                                        boxShadow:
                                                selectedChoice?.value === choice.value
                                                    ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                    : "none",
                                    }}
                                    onClick={() => { handleChoiceClick(choice) }}
                                    disabled={selectedChoice === choice}
                                >
                                    <Box component="img"
                                        src={`${imagesResources}${choice.image}`} alt={`Img ${index}`}
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>

                {/* For Answer */}
                <Box sx={{
                    backgroundColor: "rgb(122, 140, 142)",
                    borderBottom: "10px solid rgb(91, 105, 107)",
                    borderRadius: "10px",
                    padding: "10px",
                    textAlign: "center",
                    width: "822px",
                }}>
                    <h2 style={{ color: "white", textAlign: "center" }}>{answerHeader.value}</h2>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        textAlign: "center",
                    }}>
                        {answerBox.map((answer, index) => (
                            <Box key={index}
                                sx={{
                                    height: "175px",
                                    width: "150px",
                                    marginBottom: "10px",
                                    fontSize: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                    boxSizing: "border-box",
                                    padding: "4px",
                                    lineHeight: "0.8em",
                                    textAlign: "center",
                                    backgroundColor: websiteChoices[index]
                                        ? "#aad6e7"
                                        : "white",
                                    boxShadow:
                                            selectedChoice
                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                : "none",
                                    borderTop: websiteChoices[index]
                                        ? "none"
                                        : "10px solid rgb(91, 105, 106)",
                                }}
                                onClick={() => handleChoiceAssign(index)}
                            >
                            {/* For close button */}
                            {websiteChoices[index] && (
                                <Box
                                    className="selected-close-btn"
                                    sx={{
                                        top: "0px",
                                        right: "0px",
                                        fontWeight:
                                            typeof questionData.answer.value ===
                                                "object" &&
                                            !Array.isArray(
                                                questionData.answer.value
                                            )
                                                ? "normal"
                                                : "bold",
                                        width: "22px",
                                        maxHeight: "22px",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveChoice(index);
                                    }}
                                >
                                    X
                                </Box>
                            )}    
                            <Box component="span">Step {index + 1}</Box>
                            {websiteChoices[index] && (
                                <Box
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        bottom: "0",
                                        left: "0",
                                        right: "0",
                                        fontSize: "24px",
                                        lineHeight: "0.8em",
                                        textAlign: "center"
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "167px",
                                            width: "142px",
                                            boxSizing: "content-box",
                                            backgroundColor: "#aad6e7",
                                            padding: "4px",
                                            lineHeight: "0.8em",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Box component="img" src={`${imagesResources}${websiteChoices[index].image}`} alt={`Img ${index}${index}`}/>
                                    </Box>
                                </Box>
                            )}
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};